import React from 'react';
import { motion } from 'framer-motion';
interface AnimatedSectionProps {
  children: ReactNode;
  delay?: number;
  className?: string;
}
export function AnimatedSection({
  children,
  delay = 0.2,
  className = ''
}: AnimatedSectionProps) {
  return <motion.div initial={{
    opacity: 0,
    y: 30
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.7,
    ease: 'easeOut',
    delay
  }} className={className} data-id="element-64">
      {children}
    </motion.div>;
}